import React, {
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from "react";
import { IInfoPlanDevice, IClientInfo } from "./create.provider.interfaces";

interface IProps {
  children: ReactNode;
}

interface IAuthAgent {
  email: string;
  password: string;
}

type IContext = {
  step: number;
  user: IAuthAgent | null;
  client: IClientInfo | null;
  flow: string;
  setFlow: Dispatch<SetStateAction<string>>;
  setStep: Dispatch<SetStateAction<number>>;
  setUser: Dispatch<SetStateAction<IAuthAgent | null>>;
  setClient: Dispatch<SetStateAction<IClientInfo | null>>;
};

export const CreateContext = React.createContext<IContext>({} as IContext);
export const useCreateContext = () => useContext<IContext>(CreateContext);

const CreateProvider = ({ children }: IProps) => {
  const [step, setStep] = useState<number>(1);
  const [user, setUser] = useState<IAuthAgent | null>(null);
  const [flow, setFlow] = useState<string>("new");
  const [client, setClient] = useState<IClientInfo | null>(null);
  const context: IContext = useMemo(
    () => ({
      step,
      user,
      client,
      flow,
      setStep,
      setUser,
      setClient,
      setFlow,
    }),
    [step, user, client, flow],
  );
  return (
    <CreateContext.Provider value={context}>{children}</CreateContext.Provider>
  );
};

export default CreateProvider;
